import { Suspense, useState, useEffect } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, useNavigation, json, Form } from 'react-router-dom'
import { courseCost, getCourseContent, submitCourseEducation, eventidea, getEducationlevel, getFarhangsara } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import toast from 'react-hot-toast'
import styles from '../styles/module/CourseSport.module.scss'

const fileTypes = ['jpg', 'jpeg', 'png', 'tif', 'gif', 'pdf', 'doc', 'docx', 'dwg', 'xls', 'xlsx', 'mp4', 'rar', 'zip']

export const loader = async () => {
  return defer({
    user: JSON.parse(sessionStorage.getItem('Response')),
    eventidea: eventidea(`education`),
    educationlevel: getEducationlevel(),
    farhangsara: getFarhangsara(),
  })
}

export default function Idea({ title }) {
  const pageName = title
  Title(pageName)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [educationList, setEducationList] = useState()
  const [courseContent, setCourseContent] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showMosque, setShowMosque] = useState(false)
    const [showTrackingCode,setShowTrackingCode] = useState(false)
  const [cost, setCost] = useState([])
  const [isFieldsVisible, setIsFieldsVisible] = useState(false)
  const [selectedField, setSelectedField] = useState({ list: [] })
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { state } = useNavigation()
  const estimateDay = (date) => {
    let calc = Math.floor((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    console.log(date)
    return calc
  }

  const nextSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft -= slideWidth
  }

  const previesSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft += slideWidth
  }
  const handleform = async (e) => {
    const t = toast.loading(`در حال ارسال`)
    setIsLoading(true)
    e.preventDefault()

    const formData = new FormData(document.querySelector(`form`))

    // Total amount
    let total = 0
    if (selectedField.list.length > 0) {
      selectedField.list.forEach((item, i) => {
        total += parseInt(item.cost)
      })
    }
    formData.append('total_amount', total)

    // Check selected fields
    let selectedFields = selectedField.list
    if (selectedFields.length < 1) {
      toast.error(`لطفا حداقل یک کلاس انتخاب کنید`)
      toast.dismiss(t)
      setIsLoading(false)
      return
    }
    formData.append('fields', JSON.stringify(selectedFields))

    // Check files
    // if (formData.get(`file1`).name === '' || formData.get(`file2`).name === '' || formData.get(`file3`).name === '') {
    //   toast.error(`لطفا فایل های درخواستی را پیوست کنید`)
    //   toast.dismiss(t)
    //   setIsLoading(false)
    //   return
    // }

    try {
      const res = await submitCourseEducation(formData)
      console.log(res)
      if (res.result) {
        toast.dismiss(t)
        setIsLoading(false)
        toast.success(`ثبت نام با موفقیت انجام شد`)
        sessionStorage.setItem(`courseEducation`, JSON.stringify({ result: true, id: res.id }))
        //navigate(`/complaint/list`)
setShowTrackingCode(true)
        e.target.reset()
      }
    } catch (error) {
      console.log(error)
      toast.error(`خطایی رخ داده است لطفا مجدد تلاش کنید`)
      setIsLoading(false)
      toast.dismiss(t)
    }

    return null
  }

  const TotalAmount = () => {
    console.log(selectedField)
    let total = 0
    if (selectedField.list.length > 0) {
      total = selectedField.list.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.cost
      }, 0)
    }

    return <> {new Intl.NumberFormat().format(total)} تومان</>
  }

  const print = () => {
    window.print()
  }
  const FormResult = () => {
    const courseSport = JSON.parse(sessionStorage.getItem(`courseEducation`))
    if (courseSport !== null)
      return (
        <div className={`card mt-10 mb-10 border border--dark`} id={`printarea`}>
          <div className={`card__body d-flex justify-content-between align-items-center`}>
            <div>
              <b>ثبت نام کلاس های آموزشی شما با موفقیت انجام شد.</b>&nbsp;
              <b className={``} style={{ color: `var(--green)` }}>
                کدپیگیری درخواست: {courseSport.id}
              </b>
            </div>
            <button onClick={(e) => print()}>پرینت</button>
          </div>
        </div>
      )
  }
  useEffect(() => {
    document.querySelector('header span').innerText = pageName

    courseCost().then((res) => {
      console.log(res)
      setCost(res.filter((filterItem) => filterItem.type === `education`))
    })

    getCourseContent().then((res) => {
      console.log(res)
      setCourseContent(res)
    })
  }, [])

  return (
    <section className={styles.section}>
      <Link to={`../`} className="btn btn-back-top">
        بازگشت
      </Link>

      <div className="__frame" data-width={`large`}>
        {/* {courseContent && (
          <>
            <div className="card mb-10">
              <div className="card__body">
                <div dangerouslySetInnerHTML={{ __html: courseContent.filter((item) => item.type === `education`)[0].content }} />
              </div>
            </div>
          </>
        )} */}
        <Suspense fallback={<LoadingSpinner />}>
          <Await resolve={loaderData.eventidea} errorElement={<p></p>}>
            {(data) => {
              return (
                <section className={styles.sliderWrapper}>
                  <div className={`animate__animated animate__fadeInDown ${styles.arrows}`} data-count={data.length}>
                    <ul>
                      <li>
                        <button onClick={() => previesSlide()}>&#8249;</button>
                      </li>
                      <li>
                        <button onClick={() => nextSlide()}>&#8250;</button>
                      </li>
                    </ul>
                  </div>

                  <ul className={`animate__animated animate__backInUp ${styles.slidesContainer}`} id="slides-container">
                    {data.map((item, i) => {
                      return (
                        <li className={styles.slide} id="slide" key={i}>
                          <div className={styles.slideInner} style={{ columnGap: '1rem' }}>
                            <div className={styles['imageHolder']} onClick={() => window.open(`${process.env.REACT_APP_UPLOAD}images/${item.img}`, 'new')}>
                              <img alt={item.title} src={`${process.env.REACT_APP_UPLOAD}images/${item.img}`} />
                            </div>

                            <div className="d-flex flex-column align-items-start justify-content-between" style={{ height: '90%', flex: '1 1 100%' }}>
                              <h5>{item.title}</h5>
                              <p style={{ maxWidth: '600px' }}>{item.description}</p>
                              <p>
                                {item.file && (
                                  <a href={item.file} style={{ fontWeight: 'bold' }}>
                                    دانلود فایل پیوست
                                  </a>
                                )}
                              </p>
                            </div>

                            {estimateDay(`${item.at}`) < 1 ? <span className="alert alert--danger text-center">اتمام یافته</span> : ''}
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </section>
              )
            }}
          </Await>
        </Suspense>
        <div className={styles.formContainer} style={{ border: '2px solid #333' }}>
          <div className="card__body">
            <h3 style={{ fontWeight: `900`, padding: `1rem`, textAlign: `center` }}>ثبت نام کلاس های آموزشی</h3>
            <div className={styles.form}>
              <form className="form" method="post" onSubmit={(e) => handleform(e)}>
                <h5>اطلاعات فردی</h5>
                <ul className="grid grid--fit grid--gap-1" style={{ '--data-width': '190px' }}>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        نام و نام خانوادگی<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <input type={'text'} name="fullname" defaultValue={``} required />
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        موبایل<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <input type={'number'} name="phone" minLength={11} maxLength={15} required defaultValue={``} />
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        کدملی<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <input type={'text'} name="nationalcode" required defaultValue={``} />
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        شماره شناسنامه<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <input type={'text'} name="sh_sh" required defaultValue={``} />
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        تاریخ تولد<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <input type={'text'} name="birthday" required defaultValue={``} autoComplete="off" data-jdp />
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        تحصیلات<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <Suspense fallback={<LoadingSpinner />}>
                        <Await resolve={loaderData.educationlevel} errorElement={<p>⚠️Could not load</p>}>
                          {(data) => (
                            <select name="education_id" required>
                              <option value="">انتخاب کنید</option>
                              {data.map((item, i) => {
                                return (
                                  <option key={i} value={item.id}>
                                    {++i}) {item.name}
                                  </option>
                                )
                              })}
                            </select>
                          )}
                        </Await>
                      </Suspense>
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>
                        وضعیت تاهل<span style={{ color: '#ff0000' }}>*</span>
                      </label>
                      <select name="marriage" id="" required>
                        <option value="">انتخاب کنید</option>
                        <option value="0">مجرد</option>
                        <option value="1">متاهل</option>
                      </select>
                    </div>
                  </li>
                  <li>
                    <div className={styles.formGroup}>
                      <label>تلفن ثابت</label>
                      <input type={'number'} name="tel" placeholder={`همراه با کد شهر`} maxLength={12} />
                    </div>
                  </li>
                </ul>

                <div className={styles.formGroup}>
                  <label>
                    آدرس<span style={{ color: '#ff0000' }}>*</span>
                  </label>
                  <input type={'text'} name="address" defaultValue={``} required />
                </div>

                <div className={styles.formGroup}>
                  <label>
                    نام فرهنگسرا(مکان آموزشی):<span style={{ color: '#ff0000' }}>*</span>
                  </label>
                  <Suspense fallback={<LoadingSpinner />}>
                    <Await resolve={loaderData.farhangsara} errorElement={<p>⚠️Could not load</p>}>
                      {(data) => (
                        <select name="farhangsara_id" required>
                          <option value="">انتخاب کنید</option>
                          {data.map((item, i) => {
                            return (
                              <option key={i} value={item.id}>
                                {++i}) {item.name}
                              </option>
                            )
                          })}
                        </select>
                      )}
                    </Await>
                  </Suspense>
                </div>

                <div className={styles.formGroup}>
                  <label>
                    در صورت عدم شرکت در فرهنگسرا تمایل به حضور در مسجد محله را دارید؟<span style={{ color: '#ff0000' }}>*</span>
                    <br />
                    در صورت جواب بله، نام مسجد را بنویسید:
                  </label>
                  <select
                    name=""
                    id=""
                    required
                    onChange={(e) => {
                      if (e.target.value === '1') setShowMosque(true)
                      else setShowMosque(false)
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value={0}>خیر</option>
                    <option value={1}>بله</option>
                  </select>
                  {showMosque && <input type={'text'} name="mosque" required placeholder="نام مسجد" maxLength={12} defaultValue={``} />}
                </div>

                {/* <div className={styles.formGroup}>
                  <label htmlFor="">
                    در صورت عدم حضور در مکان های فوق رضایت به حضور مربی در منزل را دارید؟
                    <span style={{ color: '#ff0000' }}>*</span>
                  </label>
                  <select name="athome" id="" required>
                    <option value="">انتخاب کنید</option>
                    <option value="1">بله</option>
                    <option value="0">خیر</option>
                  </select>
                </div> */}

                <div className={styles.formGroup}>
                  <label>
                    کلاسهای آموزشی و مهارت آموزی <span style={{ color: '#ff0000' }}>*</span>
                  </label>

                  <input
                    type={`text`}
                    autoComplete="off"
                    placeholder={`جستجو در رشته ها`}
                    id="ideacategory_id"
                    onChange={(e) => {
                      if (e.target.value.length > 0) {
                        let filtered = cost.filter((item) => item.name.includes(e.target.value))
                        console.log(filtered)
                        if (filtered.length > 0) setCost(filtered)

                        //reset
                      } else courseCost().then((res) => setCost(res.filter((filterItem) => filterItem.type === `education`)))
                    }}
                    onFocus={() => {
                      setIsFieldsVisible(true)
                      //courseCost().then((res) => setCost(res))
                    }}
                  />

                  {isFieldsVisible && (
                    <div className={styles['select-popup']}>
                      {cost.length < 1 && <>موردی یافت نشد</>}
                      {cost.map((item, i) => {
                        return (
                          <>
                            <div
                              key={i}
                              id={`ideacategory_id_select${i}`}
                              onClick={() => {
                                console.log(`field selected`)
                                setCost((costVal) => costVal.filter((filterItem) => filterItem.id !== item.id))
                                setSelectedField({ list: selectedField.list.concat(item) })
                                setIsFieldsVisible(false)
                              }}
                            >
                              {++i}) {item.name} ({new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 3 }).format(item.cost)} تومان)
                            </div>
                          </>
                        )
                      })}
                      <button className="btn" onClick={() => setIsFieldsVisible(false)}>
                        بستن
                      </button>
                    </div>
                  )}
                </div>

                {selectedField && (
                  <div className={`${styles.formGroup}`}>
                    <label>رشته های انتخاب شده:</label>
                    {selectedField.list.length > 0 &&
                      selectedField.list.map((item, i) => {
                        return (
                          <div key={i} className="card mt-10">
                            <div className="card__body d-flex flex-row align-items-center justify-content-between">
                              <button
                                onClick={() => {
                                  setSelectedField({ list: selectedField.list.filter((filterItem) => filterItem.id !== item.id) })
                                  setCost((costVal) => costVal.concat(item))
                                }}
                              >
                                حذف
                              </button>
                              <span>{item.name}</span>
                              <span>{new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 3 }).format(item.cost)} تومان</span>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                )}

                <div className={styles.formGroup}>
                  <label>مبلغ کل:</label>
                  <TotalAmount />
                </div>

                <div className={styles.formGroup}>
                  <center>
                    <button
                      type="submit"
                      style={{
                        padding: '1rem',
                        background: 'linear-gradient(245.05deg, #AEFB50 13%, #64F49C 47.96%)',
                        color: 'var(--black)',
                        fontWeight: 'bold',
                      }}
                      className={styles.submitButton}
                      disabled={isLoading ? true : false}
                    >
                      ثبت و ارسال
                    </button>
                  </center>
                </div>
              </form>
            </div>
          </div>
        </div>

  {showTrackingCode &&   <FormResult />}
      </div>
    </section>
  )
}
